import React, {useState, useEffect, useContext}from 'react'
import { FirebaseContext } from '../../Services/firebase'

import BreadCount from './BreadCount';
import { Page, Document } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';

import { TextField, Button, Autocomplete, Dialog, DialogContent, InputLabel, MenuItem, Select } from '@mui/material';

import { getWeeks } from '../../Utils/getWeeks';

//import BreadTotal from './BreadTotal';

export default function RecapWeek(props) {

    const firebase = useContext(FirebaseContext)
    const [Weeks, setWeeks] = useState([]);
    const [Value, setValue] = useState('semaines');
    const [InputValue, setInputValue] = useState('');
    const [Display, setDisplay] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [Tour, setTour] = useState();

    const getRecap = () => {
        setDisplay(true)
        setOpen(true)
    }

    useEffect(() => {
        getWeeks(firebase, props.UserSession.uid, setWeeks);
    }, [firebase, props.UserSession.uid]);

    const handleClose = () => {
        setOpen(false);
        setValue('semaines')
    };

    const handleTour = (event) => {
        setTour(event.target.value);
    };

    return (
        <div style={{display: "flex"}}>
            <div style={{display: "flex", flexDirection: "column"}}>
                <Autocomplete
                    value={Value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    inputValue={InputValue}
                    onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                    }}
                    disablePortal
                    id="combo-box-demo"
                    options={Weeks}
                    sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} label="semaine" />}
                />
                <InputLabel id="demo-simple-select-label">Numéro de tournée</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={Tour}
                    label="Numéro de tournée"
                    onChange={handleTour}
                    sx={{width: "12vw"}}
                    >
                    <MenuItem value={'1'}>1</MenuItem>
                    <MenuItem value={'2'}>2</MenuItem>
                    <MenuItem value={'3'}>3</MenuItem>
                    <MenuItem value={'4'}>4</MenuItem>
                    <MenuItem value={'5'}>5</MenuItem>
                    <MenuItem value={'6'}>6</MenuItem>
                    <MenuItem value={'7'}>7</MenuItem>
                </Select>
                <Button variant="contained" style={{marginTop: "1vh", width: "8vw"}} onClick={getRecap}>Afficher</Button>
            </div>
            <div style={{display: "flex", flexDirection: "column", marginLeft: "2vw"}}>
                {
                    Display === false ? null :
                    <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={true}
                    maxWidth={'lg'}
                    >
                        <DialogContent>
                            <PDFViewer style={{width: "90vw", height: "80vh"}}>
                                <Document>
                                    <Page size="A4" orientation="portrait">
                                        <BreadCount Day={'1'} week={Value} uid={props.UserSession.uid} firebase={firebase} jour="Lundi" tour={Tour}/>
                                        <BreadCount Day={'2'} week={Value} uid={props.UserSession.uid} firebase={firebase} jour="Mardi" tour={Tour}/>
                                        <BreadCount Day={'3'} week={Value} uid={props.UserSession.uid} firebase={firebase} jour="Mercredi" tour={Tour}/>
                                        <BreadCount Day={'4'} week={Value} uid={props.UserSession.uid} firebase={firebase} jour="Jeudi" tour={Tour}/>
                                        <BreadCount Day={'5'} week={Value} uid={props.UserSession.uid} firebase={firebase} jour="Vendredi" tour={Tour}/>
                                        <BreadCount Day={'6'} week={Value} uid={props.UserSession.uid} firebase={firebase} jour="Samedi" tour={Tour}/>
                                        <BreadCount Day={'7'} week={Value} uid={props.UserSession.uid} firebase={firebase} jour="Dimanche" tour={Tour}/>
                                    </Page>
                                </Document>
                            </PDFViewer>
                        </DialogContent>
                    </Dialog>
                }
            </div>
        </div>

    )
}